import * as React from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs, WithScriptjsProps, WithGoogleMapProps } from "react-google-maps"
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';

//#region UI configuration
const strings = {
    search: 'Find location'
};
//#endregion

//#region Props & State
interface MapComponentProps extends WithScriptjsProps, WithGoogleMapProps {
    latitude: number | null;
    longitude: number | null;
    onSetLocation: (latitude: number, longitude: number) => void;
}
interface MapComponentState {
    bounds: google.maps.LatLngBounds | null;
    center: google.maps.LatLng | google.maps.LatLngLiteral
}

const initialState: MapComponentState = {
    bounds: null,
    center: { lat: 0, lng: 0 }
};
//#endregion

class MapComponent extends React.Component<MapComponentProps, MapComponentState> {

    private googleMap: GoogleMap | null;
    private searchBox: SearchBox | null;

    constructor(props: MapComponentProps) {
        super(props);

        this.state = initialState;
        this.googleMap = null;
        this.searchBox = null;
    }

    render() {
        const { latitude, longitude, onSetLocation } = this.props;
        const { bounds } = this.state;

        return (
                <GoogleMap
                    ref={ref => this.googleMap = ref}
                    defaultZoom={1}
                    defaultCenter={{ lat: 0, lng: 0 }}
                    onBoundsChanged={this.onBoundsChanged}
                    onClick={event => onSetLocation(event.latLng.lat(), event.latLng.lng())}
                >
                    {!!latitude && !!longitude && <Marker position={{ lat: latitude, lng: longitude }} />}

                    <SearchBox
                        ref={ref => this.searchBox = ref}
                        bounds={bounds ? bounds : undefined}
                        controlPosition={google.maps.ControlPosition.TOP_LEFT}
                        onPlacesChanged={this.onPlacesChanged}
                    >
                        <input
                            type="text"
                            placeholder={strings.search}
                            style={{
                                boxSizing: 'border-box',
                                border: '1px solid transparent',
                                width: 240,
                                height: 32,
                                marginTop: 8,
                                padding: '0 12px',
                                borderRadius: 3,
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                fontSize: 14,
                                outline: 'none',
                                textOverflow: 'ellipses',
                            }}
                        />
                    </SearchBox>
                </GoogleMap>
        );
    }

    private onBoundsChanged = () => {
        if (this.googleMap) {
            this.setState({
                bounds: this.googleMap.getBounds(),
                center: this.googleMap.getCenter()
            });
        }
    }

    private onPlacesChanged = () => {
        if (this.googleMap === null || this.searchBox === null) {
            return;
        }

        const places = this.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();

        places.forEach(place => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });

        this.googleMap.fitBounds(bounds);
    }
}

export default withScriptjs(withGoogleMap(MapComponent));



// WEBPACK FOOTER //
// ./src/modules/winery/MapComponent.tsx